import React from 'react';
const DealAgree = require('../../../../www/images/deal-agreement.png');
import { RaisedButton } from 'material-ui';

const SignSuccess = ({ signUp, createdContracts, downloadRatesAfterSigningSuccess }) => {
  return (
    <div style={{ margin: '2em auto' }}>
      <h4>Thank you!</h4>
      <br/>
      <b>We have received your rates and will begin loading your rates into our booking system soon.</b>
      <div style={{ margin: '2em auto' }}>
        <img src={DealAgree} width={200}/>
      </div>
      <div style={{ display: createdContracts && createdContracts.length ? 'block' : 'none', marginBottom: '1em' }}>
        <RaisedButton
          label={`Click here to download a copy of ${
            createdContracts && createdContracts.length > 1 ? 'these contracts' : 'this contract'
          } for your records`}
          labelStyle={{ textTransform: 'none' }}
          secondary
          onClick={downloadRatesAfterSigningSuccess}
        />
      </div>
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {
          `We have used TourConnect to manage this process. You can use TourConnect to:`
        }
      </div>
      <div style={{ whiteSpace: 'pre-wrap', textAlign: 'left' }}>
        {
          `
                - See when your rates have been loaded
                - Store and track all of your rates and contracts
                - Keep a full audit trail on all of your contracts
                - Manage all of your partners, contacts, and communications
          `
        }
      </div>
      <br/>
      <div>
        <small>Create an account to access all of TourConnect's benefits.</small>
      </div>
      <RaisedButton
        style={{ margin: '2em auto' }}
        label="Sign Up"
        primary
        onClick={signUp}
      />
    </div>
  );
};

export default SignSuccess;



// WEBPACK FOOTER //
// ./src/app/components/assets-landing/request/signigng-success.jsx